import postToWebView from '@/utils/post-webview'
import queryClient from '@/components/query-client'
import { addPaymentMethod, deletePaymentMethod } from './ports'

const plans = {
  name: 'plans',
  state: {},
  reducers: {},
  effects: dispatch => ({
    updatePaymentMethod: async (data, _, paymentMethodId = '') => {
      if (paymentMethodId) {
        const { error } = await dispatch.plans.deletePaymentMethod(paymentMethodId, true)
        if (error) return { error }
      }
      return dispatch.plans.addPaymentMethod(data)
    },
    addPaymentMethod: async data => {
      const { tax_code, ...rest } = data
      const newData = tax_code ? { tax_code, ...rest } : { ...rest }
      try {
        const response = await addPaymentMethod(newData)
        if (response.response.ok) {
          queryClient.setQueryData(['user', 'plans', 'payment', 'default'], () => response.body)
          postToWebView('payment_updated')
          return response
        }
        throw new Error(response.body.message || response.response.statusText)
      } catch (error) {
        console.log('[plans/addPaymentMethod]', error)
        return { error }
      }
    },
    deletePaymentMethod: async (paymentMethodId, _, keepCache) => {
      try {
        const response = await deletePaymentMethod(undefined, { paymentMethodId })
        if (response.response.ok) {
          if (!keepCache) {
            queryClient.setQueryData(['user', 'plans', 'payment', 'default'], () => [])
            queryClient.setQueryData(['payment-methods'], () => [])
            postToWebView('payment_updated')
          }
          return response
        }
        throw new Error(response.body.message || response.response.statusText)
      } catch (error) {
        console.log('[plans/deletePaymentMethod]', error)
        return { error }
      }
    }
  })
}

export default plans
